/**
 * Utility functions for the application
 */

// Smooth scroll to element
export const scrollToElement = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

// Format number with commas
export const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Truncate text
export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};

// Check if element is in viewport
export const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

// Submit form data to Google Sheets
const GOOGLE_SHEET_URL = 'https://script.google.com/macros/s/AKfycbzE5E2bKsXV9uu5-_AN2t4tLWz899s7D26HEsH9Q3-xh6_bgcYiPDllHlBMIB9TqSDr/exec';

export const submitToGoogleSheet = async (formData) => {
  const payload = {
    timestamp: new Date().toISOString(),
    name: formData.name || '',
    email: formData.email || '',
    phoneNumber: formData.phoneNumber || '',
    message: formData.message || '',
  };

  const response = await fetch(GOOGLE_SHEET_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  return response;
};

// Debounce function
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export default {
  scrollToElement,
  formatNumber,
  truncateText,
  isInViewport,
  debounce,
  submitToGoogleSheet,
};
